var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99988 4.49999V6.49999M5.99988 8.49999H6.00488M5.30754 1.94585L1.19509 9.04917C0.966991 9.44316 0.85294 9.64016 0.869797 9.80184C0.884499 9.94286 0.958384 10.071 1.07306 10.1544C1.20454 10.25 1.43217 10.25 1.88744 10.25H10.1123C10.5676 10.25 10.7952 10.25 10.9267 10.1544C11.0414 10.071 11.1153 9.94286 11.13 9.80184C11.1468 9.64016 11.0328 9.44316 10.8047 9.04916L6.69222 1.94585C6.46493 1.55327 6.35129 1.35698 6.20303 1.29105C6.0737 1.23355 5.92606 1.23355 5.79673 1.29105C5.64846 1.35698 5.53482 1.55327 5.30754 1.94585Z",
    stroke: "#D92D20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9ab0c845ba2deaf47d3a9c9926d2ddda.svg";
export { ForwardRef as ReactComponent };